import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Grid, Button, colors, IconButton } from '@material-ui/core';
import { BookmarksOutlined } from '@material-ui/icons';
import { Link } from 'react-router-dom';

import APP_NAME from 'config/app_name';

import Routes from 'config/routes';

import useIsUpMD from 'hooks/media_query/useIsUpMD';

import useAuthentication from 'domain/authentication/useAuthentication';

import HeaderTitle from 'components/typography/HeaderTitle';
import AuthenticationButtons from 'components/buttons/authentication/AuthenticationButtons';
import ProfileButton from 'components/buttons/profile/ProfileButton';

const useStyles = makeStyles((theme) => ({
  title: {
    color: colors.red[400],
    textTransform: 'none',
    fontFamily: 'Pacifico,cursive',
    '&:hover': {
      backgroundColor: colors.red[100],
      color: colors.red[100],
    },
    padding: 0,
  },
  signInButton: {
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  bookmarksButton: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  signOutButton: {
    color: colors.grey[50],
    backgroundColor: colors.deepOrange[900],
    '&:hover': {
      backgroundColor: colors.deepOrange[100],
    },
  },
}));

const Header = () => {
  const classes = useStyles();
  const { isAuthenticated } = useAuthentication();
  const isUpMD = useIsUpMD();

  return (
    <AppBar
      position="static"
      elevation={0}
      color="transparent"
      style={{ marginTop: 8, padding: 16 }}
    >
      <Grid container justify="center">
        <Grid item xs={12} sm={10} md={8} container alignItems="center">
          <Grid item style={{ flexGrow: 1 }} xs={8}>
            <Link to={Routes.HOME_PAGE} style={{ textDecoration: 'none' }}>
              <Button className={classes.title}>
                <HeaderTitle>{APP_NAME}</HeaderTitle>
              </Button>
            </Link>
          </Grid>

          <Grid item xs={4}>
            {!isAuthenticated && (
              <Grid container justify="flex-end">
                <Grid item>
                  <AuthenticationButtons
                    showCompressed={true}
                  ></AuthenticationButtons>
                </Grid>
              </Grid>
            )}

            {isAuthenticated && (
              <Grid
                container
                justify="flex-end"
                alignItems="center"
                spacing={3}
              >
                {isUpMD && (
                  <Grid item>
                    <Link
                      to={Routes.BOOKMARKS}
                      styles={{ textDecoration: 'none' }}
                    >
                      <IconButton className={classes.bookmarksButton}>
                        <BookmarksOutlined></BookmarksOutlined>
                      </IconButton>
                    </Link>
                  </Grid>
                )}

                <Grid item>
                  <ProfileButton></ProfileButton>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default Header;
